import React from 'react';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import SignInFrom from '../../components/forms/sign-in-form';

function SignIn() {
  return (
    <Container sx={{ my: 5 }}>
      <Grid container fixed justifyContent="center">
        <Grid item xs={10} sm={8} md={6}>
          <SignInFrom />
        </Grid>
      </Grid>
    </Container>
  );
}

export default SignIn;
